import { Box, Flex, MainHeadline, PageWrapper } from 'styling/GlobalStyles'
import { NavBar } from 'components/NavBar/NavBar'
import { DisplayCard } from 'components/DisplayCards/DisplayCard'
import { ContainerHeader, Container, ContainerContent } from 'components/Containers/Containers'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { Link, useNavigate } from 'react-router-dom'
import { NotYetAdded } from '../Operations.styled'

export const Overview = () => {
    const qucikLinks = [
        { name: 'Create a new plan', link: '/operations/plans/add' },
        { name: 'Safety overview', link: '/operations/safety' },
        { name: 'Safety incidents', link: '/operations/safety/incidents' },
        { name: 'Permits', link: '/operations/safety/permits' },
        { name: 'Shift programs', link: '/operations/shift-programs' },
        { name: 'Tasks', link: '/operations/tasks' },
        { name: 'Running tasks', link: '/operations/running-tasks' },
        { name: 'Completed tasks', link: '/operations/completed-tasks' },
        { name: 'Queue health', link: '/operations/queue-health' },
    ]

    const navigate = useNavigate()
    return <>
        <NavBar />
        <PageWrapper>
            <Flex>
                <MainHeadline>Overview</MainHeadline>
            </Flex>
            <Flex mt='32' mb='32' gap='1rem' >
                <DisplayCard value='N/A' label='SAFETY' borderColor='#ff9900' />
                <DisplayCard value='N/A' label='OPEN L3+' borderColor='#ff9900' />
                <DisplayCard value='N/A' label='24H PRODUCTION' borderColor='#ff9900' />
                <DisplayCard value='N/A' label='EQUIPMENT' borderColor='#ff9900' />
            </Flex>
            <Flex gap='1rem' >
                <Container style={{ width: '70%' }} >
                    <ContainerHeader>
                        <Flex width='100%' between >
                            <TitleText>Recent Activities</TitleText>
                            <OtherText onClick={() => navigate('/operations/plans')} style={{ color: '#ff9900', cursor: 'pointer' }} >All Plans</OtherText>
                        </Flex>
                    </ContainerHeader>
                    <ContainerContent>
                        <NotYetAdded>
                            <BodyText grey >No recent activities to display</BodyText>
                        </NotYetAdded>
                    </ContainerContent>
                </Container>
                <Container style={{ width: '30%' }} >
                    <ContainerHeader>
                        <TitleText>Quick Links</TitleText>
                    </ContainerHeader>
                    <ContainerContent>
                        <Flex column gap='1rem' >

                            {qucikLinks.map((link) => (
                                <Link to={link.link} key={link.name}>
                                    <Box hoverOrangeBorder >
                                        <BodyText>{link.name}</BodyText>
                                    </Box>
                                </Link>
                            ))}
                        </Flex>
                    </ContainerContent>
                </Container>
            </Flex>
        </PageWrapper>
    </>
}